module.exports = __webpack_public_path__ + "static/media/reading.c507ad3e.svg";